<template>
  <div :class="['nav', top > 0 ? 'navFixed' : '']">
    <ul class="nav-left">
      <li><img :src="top > 0 || topFixed === true? logoActive: logo" alt="" class="logo" @click="toUrl('/')"></li>
      <li v-for="(item, index) in navLeftArr" :key="index" :class="[index === topIndex? 'active': '', 'navItme']"  @click="toUrl(item.url)" @mouseenter="hoverFn(item)" @mouseleave="closeNavFn(item)">
        <p>{{item.label}}</p>
        <template v-if="item.children && item.children.length > 0">
          <el-collapse-transition>
            <ul class="childrenBox" v-show="item.childrenBox">
              <li v-for="(childrenItem, indexChildren) in item.children" :class="index === topIndex && childrenIndex === indexChildren? 'childrenActive': ''" :key="indexChildren" @click="toUrl(childrenItem.url)">
                {{childrenItem.label}}
              </li>
            </ul>
          </el-collapse-transition>
        </template>
      </li>
    </ul>
    <ul class="nav-right">
      <li v-for="(item, index) in navRightArr" :key="index" :class="[index === 0? 'btnFirst': '']">
        <template v-if="item.type==='String'">
          <p @click="getChild(index)">{{item.label}}</p>
        </template>
        <template v-else-if="item.type==='line'">
          <p class="line"></p>
        </template>
      </li>
    </ul>
    <el-dialog :visible.sync="dialogVisible" :destroy-on-close="true" width="680px" :append-to-body="true">
      <div class="box">
        <div class="title">微信扫码，联系商务人员进行业务咨询</div>
        <img :src="i1" alt="" class="img">
        <div class="scal">微信扫一扫</div>
        <div class="phone">联系电话：0755-29739988   0755-29001122</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import logo from '../assets/images/logo.png'
import logoActive from '../assets/images/logoActive.png'
import i1 from '../assets/images/product/1.png'
import dialogBusiness from './dialogBusiness'
export default {
  name: 'navTop',
  data () {
    return {
      navLeftArr: [
        {'label': '首页', url: '/'},
        {
          'label': '产品体系',
          'childrenBox': false,
          'children': [
            {'label': 'SaaS系统', 'url': '/saas'},
            {'label': '数据中台', 'url': '/dataCenter'},
            {'label': '物联平台', 'url': '/association'},
            {'label': '智绘简报', 'url': '/briefing'},
            {'label': '聚合支付', 'url': '/payment'},
            {'label': '客流监控', 'url': '/monitor'}
          ]
        },
        {
          'label': '解决方案',
          'childrenBox': false,
          'children': [
            {'label': '游乐场', 'url': '/amusement'},
            {'label': '设备运营商', 'url': '/equipment'}
          ]
        },
        {'label': '智绘商城', url: '/mall'},
        {'label': '关于智绘', url: '/about'}
      ],
      navRightArr: [
        {'label': '商户登录', 'url': '', 'type': 'String'},
        {'label': '试用申请', 'url': '', 'type': 'String'},
        {'type': 'line'},
        {'label': '开发者登录', 'url': '', 'type': 'String'}
      ],
      top: 0,
      logo: logo,
      logoActive: logoActive,
      dialogVisible: false,
      i1: i1,
      only: true
    }
  },
  components: {
    dialogBusiness
  },
  props: {
    topIndex: {
      type: Number
    },
    childrenIndex: {
      type: Number
    },
    topFixed: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    document.documentElement.scrollTop = 0
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleScroll (e) {
      this.top = e.target.documentElement.scrollTop || e.target.body.scrollTop || e.target.scrollTop
    },
    toUrl (url) {
      if (url && url !== this.$route.path) {
        this.$router.push(url)
      }
    },
    getChild (index) {
      if (index === 1) {
        this.dialogVisible = true
      }
    },
    closeFn (v) {
      this.dialogVisible = v
    },
    hoverFn (item) {
      item.childrenBox = true
    },
    closeNavFn (item) {
      item.childrenBox = false
    }
  }
}
</script>

<style scoped>
  .nav{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .navFixed{
    background-color: #ffffff;
    border-bottom:1px solid rgba(240,241,242,1);
  }
  .navFixed .nav-left>li, .navFixed .nav-right>li{
    color:rgba(102,102,102,1);
  }
  .navFixed .nav-left>li:hover, .navFixed .nav-right>li:hover {
    color:rgba(252,189,1,1);
  }
  .navFixed .nav-right .btnFirst, .navFixed .nav-right .btnFirst:hover{
    color: #ffffff;
  }
  .navFixed .nav-left .active{
    color:rgba(252,189,1,1);
    border-bottom: 3px solid rgba(252,189,1,1);
  }
  .nav-left, .nav-right{
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .nav-left>li, .nav-right>li{
    font-size: 17px;
    font-family:MicrosoftYaHei;
    color: rgba(255, 255, 255, .7);
    padding: 10px 10px 20px;
    margin-right: 20px;
    text-align: center;
    cursor: pointer;
  }
  .nav-left>li:hover, .nav-right>li:hover{
    border-bottom: none;
    color:rgba(252,189,1,1);
  }
  .nav-left li:first-child{
    padding-bottom: 0;
  }
  .navItme{
    position: relative;
  }
  .childrenBox{
    min-width: 100%;
    width: -moz-max-content;
    width: -webkit-max-content;
    width: -o-max-content;
    width: -ms-max-content;
    position: absolute;
    top: 60px;
    left: 0;
    color: rgba(0,0,0,.65);
    background: #ffffff;
    border-radius: 5px;
    padding: 0 10px;
    border-top: 3px solid rgba(252,189,1,1);
    box-shadow:0px 2px 10px rgba(0,0,0,0.16);
    text-align: left;
  }
  .childrenBox>li{
    line-height: 200%;
    padding: 0 10px;
  }
  .childrenBox>li:hover{
    color:rgba(252,189,1,1);
  }
  .childrenBox .childrenActive{
    color:rgba(252,189,1,1);
  }
  .childrenBox>li:first-child{
    margin-top: 5px;
  }
  .childrenBox>li:last-child{
    margin-bottom: 5px;
  }
  .nav-left .active{
    border-bottom: 3px solid #fff;
    color: rgba(255, 255, 255, 1);
  }
  .nav-right .btnFirst{
    background:rgba(252,189,1,1);
    color: #ffffff;
    opacity:1;
    border-radius:2px;
    padding: 5px 10px;
    margin-bottom: 8px;
  }
  .nav-right .btnFirst:hover{
    color: #ffffff;
  }
  .logo{
    width:128px;
    margin-bottom: 10px;
  }
  .nav-right li:nth-child(2),
  .nav-right li:nth-child(3){
    margin-right: 0;
  }
  .line{
    width: 2px;
    height: 15px;
    background: #ccc;
  }
  .box{
    width: 500px;
    background: #ffffff;
    margin: auto;
    text-align: center;
  }
  .title{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:28px;
    color:rgba(0,0,0,1);
    margin-bottom: 26px;
  }
  .scal{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:28px;
    color:rgba(102,102,102,1);
    margin-bottom: 18px;
  }
  .phone{
    font-size:20px;
    font-family:DIN;
    font-weight:500;
    line-height:28px;
    color:rgba(51,51,51,1);
    margin-bottom: 22px;
  }
  .img{
    width: 294px;
    height:294px;
    margin-bottom: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/nav.vue